export default __webpack_public_path__ + "static/media/T4-output1.5e10b5e0.png";